import { createWithEqualityFn } from 'zustand/traditional'
import { shallow } from "zustand/shallow"
import createCallFormSlice from "./slices/CallFormSlice"

const useStore = createWithEqualityFn((set, get) => ({
  ...createCallFormSlice(set, get),
}), shallow)

export default useStore
